import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'https://api.talktokam.com';

let sharedSocket = null;
let sharedUserId = null;

export const useSocket = (userId, onMessage) => {
  const [connected, setConnected] = useState(false);
  const callbackRef = useRef(onMessage);
  callbackRef.current = onMessage;

  useEffect(() => {
    if (!userId) return;
    if (sharedSocket && sharedSocket.connected && sharedUserId === userId) return;
    if (sharedSocket) { sharedSocket.disconnect(); sharedSocket = null; }

    const socket = io(SOCKET_URL, {
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });
    sharedSocket = socket;
    sharedUserId = userId;

    socket.on('connect', () => {
      setConnected(true);
      socket.emit('join-agent', { agentId: userId, ownerId: userId });
    });

    socket.on('disconnect', () => setConnected(false));
    socket.on('connect_error', (err) => console.warn('Socket connect_error:', err.message));

    socket.on('wa_message_incoming', (data) => {
      if (callbackRef.current) callbackRef.current(data);
    });

    return () => {};
  }, [userId]);

  return { connected, socket: sharedSocket };
};